import type { FC, ReactNode } from 'react'
import type { VariantProps } from 'class-variance-authority'

import SiTelegram from '@icons-pack/react-simple-icons/icons/SiTelegram'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@/components/ui/button'
import { siteConfig } from '@/constants/site'

interface TelegramLinkProps extends VariantProps<typeof buttonVariants> {
    children: ReactNode
    className?: string
}

export const TelegramLink: FC<TelegramLinkProps> = ({
    children,
    className,
    variant = 'outline',
    size = 'default'
}): ReactNode => {
    return (
        <a
            href={siteConfig.links.telegramBot}
            target='_blank'
            rel='noopener noreferrer'
            className={cn(buttonVariants({ variant, size }), className)}
        >
            <SiTelegram title='' aria-hidden={true} />

            {children}

            <span className='sr-only'>
                (opens Telegram in a new tab)
            </span>
        </a>
    )
}
